import { useLocation } from "@reach/router"
import { useEffect } from "react"

import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { CHECKOUT_STEPS, QUERY_STRING_PROPS } from "~config/constants"
import usePersistedWidgetCheckoutParamsString from "~utils/use-persisted-widget-checkout-params-string"

export default function useAutoPersistWidgetCheckoutSession() {
    const { listing, isWidget } = useCheckoutFlow()
    const { search } = useLocation()
    const { persistCheckoutParamsString } =
        usePersistedWidgetCheckoutParamsString(listing?.id)

    // Start persisting the params once we pass the package step.
    // The package step is where we check for previous sessions, so we
    // don't want to overwrite stored params before the user decides.
    // Don't persist on the confirmation step since the flow is complete
    // and we'll be clearing the persisted data.
    useEffect(() => {
        if (!isWidget) return

        const params = new URLSearchParams(search)
        const currentStep = params.get(QUERY_STRING_PROPS.STEP)

        const isPackageStep = currentStep === CHECKOUT_STEPS.WIDGET_PACKAGE
        const isConfirmationStep = currentStep === CHECKOUT_STEPS.CONFIRMATION

        if (isPackageStep || isConfirmationStep || !currentStep || !search) {
            return
        }

        persistCheckoutParamsString(search)
    }, [search, isWidget])
}
